import { useFetch } from '@chipinside/fetcher'
import React from 'react'

import LinearLoader from '#/components/Loader/Linear'

export function DrawerFetch({
  controller,
  marker,
  render,
}: {
  controller?: string | null
  render: (data: any) => React.ReactNode
  marker?: any
}) {
  if (!controller) render(marker)

  try {
    const { data, isLoading } = useFetch<any>({ controller })

    return isLoading ? <LinearLoader loading variant={'indeterminate'} /> : render(data)
  } catch {
    return <LinearLoader failed loading={false} />
  }
}
